import { render, staticRenderFns } from "./WxeTable.vue?vue&type=template&id=49a3c1d9&"
import script from "./WxeTable.vue?vue&type=script&lang=js&"
export * from "./WxeTable.vue?vue&type=script&lang=js&"
import style0 from "./WxeTable.vue?vue&type=style&index=0&id=49a3c1d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports